import { StudentTasksPage } from "../pages/StudentPanel/Tarefas/index.jsx";
import { InstitutionPortalPage } from "../pages/InstitutionPanel/index.jsx";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  HashRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import LoginAlunoPage from "../pages/StudentPanel/LoginAluno";
import LoginAdminPage from "../pages/AdminPanel/pages/Login";
import ExtratoPage from "../pages/StudentPanel/Extrato";
import MeritosPage from "../pages/StudentPanel/Meritos";
import TransferirPage from "../pages/StudentPanel/Transferir";
import CardapioPage from "../pages/StudentPanel/Cardapio";
import ConteudosPage from "../pages/StudentPanel/Conteudos";
import VestibularesPage from "../pages/StudentPanel/Vestibulares";
// import SimuladoresPage from "../pages/StudentPanel/Simuladores"; // comentado
import { SimuladoresConteudoStudentPage as SimuladoresConteudoPage } from "../pages/StudentPanel/SimuladoresConteudo";
import { OlimpiadaConteudoStudentPage as OlimpiadaConteudoPage } from "../pages/StudentPanel/OlimpiadaConteudo";
import RankingsPage from "../pages/StudentPanel/Rankings";
import DesafiosPage from "../pages/StudentPanel/Desafios";
import FeedPage from "../pages/StudentPanel/Feed";
import PerfilPage from "../pages/StudentPanel/Perfil";
import AgendamentosPage from "../pages/StudentPanel/Agendamentos";
import AdminPanelPage from "../pages/AdminPanel";
import {
  isScreenAllowed,
  resolveStudentHomeScreen,
} from "../shared/accessControl";
const normalizePath = (path) => {
  if (!path || path === "/") return "/";
  return path.endsWith("/") ? path.slice(0, -1) : path;
};
export const ROUTE_PATHS = {
  "login-aluno": "/login-aluno",
  "login-admin": "/login-admin",
  feed: "/inicio",
  rankings: "/rankings",
  loja: "/loja",
  desafios: "/desafios",
  meritos: "/meritos",
  transferir: "/transferir",
  perfil: "/perfil",
  extrato: "/extrato",
  agendar: "/agendamentos",
  cardapio: "/cardapio",
  conteudos: "/conteudos",
  tarefas: "/tarefas",
  vestibulares: "/vestibulares",
  "simuladores-conteudo": "/simuladores",
  "olimpiada-conteudo": "/olimpiada",
  admin: "/admin",
};
export function getPathFromView(view) {
  return ROUTE_PATHS[view] || ROUTE_PATHS.feed;
}
export function getViewFromPath(pathname) {
  const normalizedPath = normalizePath(pathname);
  const foundEntry = Object.entries(ROUTE_PATHS).find(
    ([, path]) => normalizePath(path) === normalizedPath,
  );
  return foundEntry ? foundEntry[0] : "login-aluno";
}
export function AppRouterProvider({ children }) {
  // A mesma navegação usada pelo login e pelos portais publicados.
  return <HashRouter>{children}</HashRouter>;
}
export function useAppNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentRouteView = getViewFromPath(location.pathname);
  const [view, setView] = useState(currentRouteView);
  const [viewHistory, setViewHistory] = useState([]);
  const currentRouteViewRef = useRef(currentRouteView);
  const viewHistoryRef = useRef([]);
  useEffect(() => {
    viewHistoryRef.current = viewHistory;
  }, [viewHistory]);
  useEffect(() => {
    if (currentRouteViewRef.current !== currentRouteView) {
      currentRouteViewRef.current = currentRouteView;
      setView(currentRouteView);
    }
  }, [currentRouteView]);
  const gotoView = useCallback(
    (nextView) => {
      const nextHistory =
        nextView === currentRouteViewRef.current
          ? viewHistoryRef.current
          : [...viewHistoryRef.current.slice(-9), currentRouteViewRef.current];
      viewHistoryRef.current = nextHistory;
      setViewHistory(nextHistory);
      currentRouteViewRef.current = nextView;
      setView(nextView);
      navigate(getPathFromView(nextView));
    },
    [navigate],
  );
  const goBackView = useCallback(() => {
    if (viewHistoryRef.current.length === 0) return false;
    const previousView =
      viewHistoryRef.current[viewHistoryRef.current.length - 1];
    const nextHistory = viewHistoryRef.current.slice(0, -1);
    viewHistoryRef.current = nextHistory;
    setViewHistory(nextHistory);
    currentRouteViewRef.current = previousView;
    setView(previousView);
    navigate(getPathFromView(previousView));
    return true;
  }, [navigate]);
  return {
    view,
    canGoBack: viewHistory.length > 0,
    gotoView,
    goBackView,
  };
}
export function AppRoutes(props) {
  let ctx = props.ctx;
  let currentStudent = props.currentStudent;
  let adminLogged = props.adminLogged;
  let agendamentos = props.agendamentos;
  const pageResetKeys = ctx.pageResetKeys;
  const pageResetKeysFeed = undefined === pageResetKeys ? {} : pageResetKeys;
  const loggedHome =
    adminLogged && !currentStudent
      ? "/admin"
      : getPathFromView(resolveStudentHomeScreen(currentStudent));
  const isLogged = Boolean(currentStudent || adminLogged);
  const allowed = (screenKey) =>
    !currentStudent || isScreenAllowed(currentStudent, screenKey);
  const redirectIfLogged = <Navigate to={loggedHome} replace={true} />;
  const redirectIfLoggedOut = <Navigate to={"/login-aluno"} replace={true} />;
  const redirectStudentFallback = <Navigate to={loggedHome} replace={true} />;
  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Navigate
            to={isLogged ? loggedHome : "/login-aluno"}
            replace={true}
          />
        }
      />
      <Route
        path={ROUTE_PATHS["login-aluno"]}
        element={
          isLogged ? (
            redirectIfLogged
          ) : (
            <LoginAlunoPage
              {...{
                ...ctx,
              }}
            />
          )
        }
      />
      <Route
        path={ROUTE_PATHS["login-admin"]}
        element={
          isLogged ? (
            redirectIfLogged
          ) : (
            <LoginAdminPage
              {...{
                ...ctx,
              }}
            />
          )
        }
      />
      <Route
        path={"/feed"}
        element={<Navigate to={ROUTE_PATHS.feed} replace={true} />}
      />
      <Route
        path={ROUTE_PATHS.feed}
        element={
          isLogged && allowed("feed") ? (
            <FeedPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.feed}
            />
          ) : isLogged ? (
            redirectStudentFallback
          ) : (
            redirectIfLoggedOut
          )
        }
      />
      <Route
        path={ROUTE_PATHS.rankings}
        element={
          isLogged && allowed("rankings") ? (
            <RankingsPage
              {...{
                ...ctx,
                agendamentos,
              }}
              key={pageResetKeysFeed.rankings}
            />
          ) : isLogged ? (
            redirectStudentFallback
          ) : (
            redirectIfLoggedOut
          )
        }
      />
      <Route
        path={ROUTE_PATHS.loja}
        element={<Navigate to={ROUTE_PATHS.cardapio} replace={true} />}
      />
      <Route
        path={ROUTE_PATHS.desafios}
        element={
          currentStudent && allowed("desafios") ? (
            <DesafiosPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.desafios}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.meritos}
        element={
          currentStudent && allowed("meritos") ? (
            <MeritosPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.meritos}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.transferir}
        element={
          currentStudent && allowed("transferir") ? (
            <TransferirPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.transferir}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.perfil}
        element={
          isLogged ? (
            <PerfilPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.perfil}
            />
          ) : (
            redirectIfLoggedOut
          )
        }
      />
      <Route
        path={ROUTE_PATHS.extrato}
        element={
          currentStudent && allowed("extrato") ? (
            <ExtratoPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.extrato}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.agendar}
        element={
          currentStudent && allowed("agendar") ? (
            <AgendamentosPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.agendar}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.cardapio}
        element={
          currentStudent && allowed("cardapio") ? (
            <CardapioPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.cardapio}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.conteudos}
        element={
          currentStudent && allowed("conteudos") ? (
            <ConteudosPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.conteudos}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.tarefas}
        element={
          currentStudent && allowed("tarefas") ? (
            <StudentTasksPage
              ctx={ctx}
              student={currentStudent}
              key={pageResetKeysFeed.tarefas}
            />
          ) : isLogged ? (
            redirectStudentFallback
          ) : (
            redirectIfLoggedOut
          )
        }
      />
      <Route
        path={ROUTE_PATHS.vestibulares}
        element={
          currentStudent && allowed("vestibulares") ? (
            <VestibularesPage
              {...{
                ...ctx,
              }}
              key={pageResetKeysFeed.vestibulares}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS["simuladores-conteudo"]}
        element={
          currentStudent && allowed("simuladores-conteudo") ? (
            <SimuladoresConteudoPage
              simuladoresConteudo={ctx.simuladoresConteudo}
              setSimuladoresConteudo={ctx.setSimuladoresConteudo}
              currentStudent={currentStudent}
              showFlash={ctx.showFlash}
              simuladoresConteudoNavigationTarget={
                ctx.simuladoresConteudoNavigationTarget
              }
              setSimuladoresConteudoNavigationTarget={
                ctx.setSimuladoresConteudoNavigationTarget
              }
              key={pageResetKeysFeed["simuladores-conteudo"]}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS["olimpiada-conteudo"]}
        element={
          currentStudent && allowed("olimpiada-conteudo") ? (
            <OlimpiadaConteudoPage
              olimpiadaConteudo={ctx.olimpiadaConteudo}
              setOlimpiadaConteudo={ctx.setOlimpiadaConteudo}
              currentStudent={currentStudent}
              showFlash={ctx.showFlash}
              olimpiadaConteudoNavigationTarget={
                ctx.olimpiadaConteudoNavigationTarget
              }
              setOlimpiadaConteudoNavigationTarget={
                ctx.setOlimpiadaConteudoNavigationTarget
              }
              key={pageResetKeysFeed["olimpiada-conteudo"]}
            />
          ) : (
            redirectStudentFallback
          )
        }
      />
      <Route
        path={ROUTE_PATHS.admin}
        element={
          adminLogged ? (
            <AdminPanelPage
              {...{
                ...ctx,
              }}
            />
          ) : (
            redirectIfLoggedOut
          )
        }
      />
      <Route path={"/instituicao"} element={<InstitutionPortalPage />} />
      <Route path={"/professor"} element={<InstitutionPortalPage />} />
      <Route
        path={"*"}
        element={
          <Navigate
            to={isLogged ? loggedHome : "/login-aluno"}
            replace={true}
          />
        }
      />
    </Routes>
  );
}
